import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Divider, 
  Paper,
  Stack 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { Plate } from '../../../types/plate';
import { EventShortList } from '../home/EventShortList';
import { useTranslation } from 'react-i18next';

interface PlateReportFormProps {
  title: string;
  plate: Plate | null;
  onCancel: () => void;
}

const PlateReportForm: React.FC<PlateReportFormProps> = ({ title, plate, onCancel }) => {
  const { t } = useTranslation();
  
  const handleGenerateReport = () => {
    console.log(`Generating report for: ${plate}`);
    // Логика формирования отчета будет здесь
  };

  return (
    <Paper elevation={0} sx={{ p: 0, width: '100%', maxWidth: 500, borderRadius: 2 }}>
      {/* Шапка формы */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
        {/* <Button onClick={onCancel} sx={{ minWidth: 'auto', color: 'text.secondary' }}>
          <CloseIcon />
        </Button> */}
      </Box>

      <Divider sx={{ mb: 3 }} />

      {/* Основной контент (наполнение будет позже) */}
      <Box sx={{ mb: 4, minHeight: '100px' }}>
        <Typography variant="body1" gutterBottom>
          {/* Обраний номер: <strong>{plate?.registration_number || 'Не вибрано'}</strong> */}
          {t('PlateReportForm.LicensePlate')}: <strong>{plate?.registration_number || t('PlateReportForm.NoData')}</strong>
        </Typography>
        
        {/* Место для будущих полей (даты, фильтры и т.д.) */}
        {/* <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', mt: 2 }}>
          Тут будуть налаштування звіту та додаткові параметри...
        </Typography> */}

        <EventShortList
            plate={plate}
        />

      </Box>

      {/* <Divider sx={{ mb: 3 }} /> */}

      {/* Кнопки действий */}
      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Button 
          variant="outlined" 
          color="inherit" 
          onClick={onCancel}
        >
          {t('PlateReportForm.Cancel')}
        </Button>
        {/* <Button 
          variant="contained" 
          color="primary" 
          startIcon={<DownloadIcon />}
          onClick={handleGenerateReport}
          disabled={!plate}
        >
          {t('PlateReportForm.Report')}
        </Button> */}
      </Stack>
    </Paper>
  );
};

export default PlateReportForm;